<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'hort-header.png)'}">
        <div class="row">
            <div style="width:10%"></div>
            <!-- <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:56%">
                <h1  class="text-center whiteText" style="width:56%">
                    <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'" class="DINNextLTPro-Black whiteText headerImageTextLarge" style="font-size:43px; text-transform: uppercase;">HORTICULTURE</h1>
                    <h1 *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:56%">
                        <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'" class="DINNextLTPro-Black whiteText headerImageTextLarge" style="font-size:43px; text-transform: uppercase;">SUPPORTING
                        GENERATIONS<br> OF GROWERS</h1>                    
            </div> -->
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">
                    HORTICULTURE</h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">
                    SUPPORTING THE GROWTH OF HEALTHY, MARKETABLE<BR>NURSERY & GREENHOUSE PLANTS</h1>
            </div>
            <div style="width:10%"></div>
        </div>
    </div>

    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:70px; padding-bottom:70px">
            <h3 class="DIN2014Regular blackText harrellsProvides">
                At Harrell’s, we understand the unique challenges growers face when cultivating high-quality plants in
                nursery and greenhouse production. That’s why we offer a full line of premium fertilizers, innovative
                plant-protection products, and expert support to help you achieve consistent growth and healthier
                plants.<br> <br>Our trusted solutions, including custom-blended nutrition programs and advanced
                controlled release technologies like POLYON®, give you the precision and reliability you need to
                maximize results. Partner with Harrell’s and grow with confidence because your success is our priority.
            </h3>
        </div>
        <div class="col-md-2"></div>
    </div>

    <div class="row cremeBackground text-center whiteText" style="margin: auto; padding-top:70px">
        <div class="text-center p-0" style="margin-top:10px; margin-bottom:10px">
            <div style="display:inline-block; position:relative; top:38px">
                <img class="topFourImages" style="object-fit: cover; object-position:center;"
                    src="{{this.pageImagePaths + 'hort1.jpg'}}" alt="POLYON & Custom-Blended Fertilizer">
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    POLYON®</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    CONTROLLED-RELEASE</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    FERTILIZER</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'hort2.jpg'}}" alt="Custom Blended Fertilizer">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    CUSTOM-BLENDED</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    FERTILIZER</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'hort3.jpg'}}" alt="Trusted Chemistry">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    PLANT</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    PROTECTION</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'hort4.jpg'}}" alt="Premium Lawn Seed">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    WATER SOLUBLE</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    FERTILIZER</h4>
            </div>
        </div>
    </div>

    <div class="whiteBackground">
        <div class="row whiteBackgroundtext-center" style="margin: auto; ">
            <div class="row" style="width:80%; max-width:1030px; margin:auto;">
                <h3 class="Din2014Regular blueText"
                    style="text-align:center; font-size:30px; font-weight:700; letter-spacing:.39px; padding-top:80px">
                    “We have counted on Harrell’s POLYON® Fertilizer to produce high-quality ornamentals for over 15 years. Harrell’s service is the best there is.”</h3>
                <h3 class="Caecilia76BoldItalic"
                    style="color:#00853E; text-align:center; font-size:20px; font-weight:700; padding-top:60px; padding-bottom:80px">
                    -Dan Baston, President & CEO | Green Forest Nursery, Inc.</h3>
            </div>

        </div>
        <app-customerform></app-customerform>

   
        <div class="lightCremeBackground">
            <div class="row lightCremeBackground yourPartnerForSuccess" id="partnersSuccessBlock">
                <div class="col-lg-4 greenText lightCremeBackground" style="padding-right:0px; padding-left:0px">
                    <h3 class="Caecilia76BoldItalic yourPartnerForSuccessDetail">
                        Harrell's Is Your<br />Partner For Success</h3>
                </div>
                <div class="col-lg-8">
                    <div class="row lightCremeBackground" style="padding-right:10%;">
                        <div class="col-lg-4 blueText text-center yourPartnerForSuccessBorder">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    PH.D'S INNOVATING
                                    <br>
                                    PRODUCTS AND
                                    <br>
                                    PROGRAMS
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                                </h4>
                            </div>
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                            <div class="margin:10px">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText pb-5"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    IT PROVIDING <BR> PROPRIETARY <BR> TECH
                                </h4>
                            </div>
                            <div class="margin:10px;">
                                <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                    src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                                <h4 class="DIN2014Bold blueText"
                                    style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                    CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-12 whiteBackground greenText" style="padding-top:5%">
                <h4 class="Caecilia76BoldItalic" style="text-align: center; font-size:28px; line-height: 46px;">
                    Products You Can Count On From Leading Manufacturers</h4>
            </div>
        </div> -->

    </div>


    <div class="row">
        <div class="col-12 whiteBackground greenText" style="padding-top:70px">
            <h4 class="Caecilia76BoldItalic" style="text-align: center; font-size:28px; line-height: 46px;">
                Products You Can Count On From Leading Manufacturers</h4>
        </div>
    </div>
    <div class="row pb-5">
        <div class="col text-center">
            <img style="margin-top:45px; height:40px" src="{{this.pageImagePaths + 'logo-2-fpo.jpg'}}"
                alt="Polyon fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:6%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-3-fpo.png'}}" alt="Envu fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:6%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-6-fpo.png'}}" alt="Syngenta fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:18%; height:40px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-4-fpo.png'}}" alt="BASF fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-5-fpo.png'}}" alt="Envu fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-1-fpo.png'}}" alt="HarrelsMax fpo image">
        </div>
    </div>

    <app-blogsbymarketpage></app-blogsbymarketpage>

    <app-toolsforthetrade></app-toolsforthetrade>
 
</div>